import React, { useState, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { useSimpleProduct } from '../../../../../../../../../hooks/newSimpleProduct';

import TabPanel from '../../../../../components/TabPanel';
import Detalhes from './tabs/Detalhes';
import Complementos from './tabs/Complementos';

import {
  NewComplementoGrupo,
  CloseButton,
  DrawerTitle,
  DrawerContainer,
} from '../../../../../drawer_styles';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

interface ComplementoProps {
  isEnabled: boolean;
  grupo_produto_id?: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const Complemento: React.FC<ComplementoProps> = ({
  isEnabled,
  grupo_produto_id,
}) => {
  const [value, setValue] = useState(0);
  const [itemComplementoReleased, setItemComplementoReleased] = useState(false);

  const classes = useStyles();
  const {
    itensComplementoReleased,
    complementoDrawerOpen,
    handleSetComplementoDrawerOpen,
  } = useSimpleProduct();

  useEffect(() => {
    if (!complementoDrawerOpen) {
      setItemComplementoReleased(false);
      setValue(0);
    } else if (itensComplementoReleased) {
      setItemComplementoReleased(true);
      setValue(1);
    } else {
      setItemComplementoReleased(false);
      setValue(0);
    }
  }, [itensComplementoReleased, complementoDrawerOpen]);

  const handleChange = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ): void => {
    setValue(newValue);
  };

  const toggleDrawer = (open: boolean) => () => {
    handleSetComplementoDrawerOpen(open);

    if (!open) setValue(0);
  };

  return (
    <>
      <NewComplementoGrupo onClick={toggleDrawer(true)} disabled={!isEnabled}>
        + Criar Grupo de Complementos
      </NewComplementoGrupo>

      <Drawer
        anchor="right"
        open={complementoDrawerOpen}
        onClose={toggleDrawer(false)}
      >
        <CloseButton onClick={toggleDrawer(false)} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation" className={classes.noPaddingTop}>
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle className="titleDrawer_with_tabs">
                <h1>Complementos</h1>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.root}>
                <AppBar
                  position="static"
                  color="transparent"
                  className={classes.noShadow}
                >
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="product tabs"
                    className={classes.tabBorder}
                  >
                    <Tab label="Detalhes" {...a11yProps(0)} />
                    <Tab
                      label="Complementos"
                      {...a11yProps(1)}
                      disabled={!itemComplementoReleased}
                    />
                  </Tabs>
                </AppBar>

                <TabPanel value={value} index={0}>
                  <Detalhes />
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <Complementos grupo_produto_id={grupo_produto_id} />
                </TabPanel>
              </div>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
};

export default Complemento;
